module.exports = __webpack_public_path__ + "media/top/clock-01eb6564.svg";